import { motion } from 'framer-motion';
const MotionSlide = (props) => {

  const style = {
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "50",
    top: 0,
    left: 0,
    background: "#2982DE"
  }

  const wrapStyle = {
    width: props.width ? props.width : "fit-content",
    height: props.height ? props.height :  "fit-content",
    position: "relative",
    margin: props.type == 'center' ? '0 auto' : 'unset',
    zIndex: "0"
  }

  return(
    <>
      <motion.div
        style={wrapStyle}
        variants={{
          offscreenWrap: { // 画面外の場合のスタイル
            opacity: 1,
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          },
          onscreenWrap: { // 画面内の場合のスタイル
            opacity: 1,
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            transition: {
              duration: 0.3,
              ease: "easeInOut",
            },
          },
        }}
        initial="offscreenWrap" // 初期表示はoffscreen
        whileInView="onscreenWrap" // 画面内に入ったらonscreen
        viewport={{ once: true}}
      >
        <motion.div
          style={style}
          variants={{
            offscreen: { // 画面外の場合のスタイル
              opacity: 1,
              clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
            },
            onscreen: { // 画面内の場合のスタイル
              opacity: 1,
              clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)",
              transition: {
                duration: 0.3,
                ease: "easeInOut",
                delay: 0.4
              },
            },
          }}
          initial="offscreen" // 初期表示はoffscreen
          whileInView="onscreen" // 画面内に入ったらonscreen
          viewport={{ once: true, amount: 0 }}
        />
        { props.children }
      </motion.div>
    </>
  )

}

export default MotionSlide;
